import { Controller } from "@hotwired/stimulus"
import { driver } from "driver.js"

export default class extends Controller {
  static targets = ["start"]
  static values = {
    config: Object,
    tourId: String,
    viewTourUrl: String,
    autoplay: Boolean,
    userHasSeen: Boolean
  }

  connect() {
    this.initializeTour()

    // Listen for external tour trigger events
    this.boundHandleExternalTrigger = this.handleExternalTrigger.bind(this)
    document.addEventListener('start-tour', this.boundHandleExternalTrigger)

    if (this.autoplayValue && !this.userHasSeenValue) {
      this.startTour()
    }
  }

  handleExternalTrigger(event) {
    // Check if this event is meant for this specific tour
    if (event.detail.tourId === this.tourIdValue) {
      console.log(`Starting tour: ${this.tourIdValue}`)
      this.startTour()
    }
  }

  initializeTour() {
    // Add the onDestroyStarted callback to the config
    const config = { ...this.configValue }

    // Filter out steps whose elements don't exist on the DOM (due to icomplete profile or other conditionals)
    if (config.steps) {
      config.steps = config.steps.filter(step => {
        const element = document.querySelector(step.element)
        if (!element) {
          console.log(`Tour step skipped - element not found: ${step.element}`)
          return false
        }
        return true
      })
    }

    config.onDestroyed = () => {
      this.markTourAsViewed()
    }

    this.tourDriver = driver(config)
  }

  startTour() {
    if (this.tourDriver) {
      this.tourDriver.drive()
    }
  }

  markTourAsViewed() {
    fetch(this.viewTourUrlValue, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
      },
      credentials: 'same-origin'
    })
  }

  // Action to manually start tour (triggered by clicking start button)
  start(event) {
    event.preventDefault()
    this.startTour()
  }

  // Clean up when controller disconnects
  disconnect() {
    // Remove event listener
    if (this.boundHandleExternalTrigger) {
      document.removeEventListener('start-tour', this.boundHandleExternalTrigger)
    }

    if (this.tourDriver) {
      this.tourDriver.destroy()
    }
  }
}